import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitControlWithStateModel } from '@apps-common/types/portal/unit-control'

export const QUERY_KEY_MY_MONITORING_GET_CONTROL_LIST_WITH_STATE = (unitId?: string) =>
  ['getMyMonitoringControlListWithState', unitId].filter(Boolean)

const getMyMonitoringControlListWithState = async (unitId?: string): Promise<IUnitControlWithStateModel[]> =>
  axios.get(`/my-monitoring/control/GetControlListWithState?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getMyMonitoringControlListWithState

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId?: string
}

export const useMyMonitoringGetControlListWithState = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_CONTROL_LIST_WITH_STATE(unitId),
    queryFn: () => getMyMonitoringControlListWithState(unitId)
  })
